import React from "react";
import { SanityBlockQuote } from "../../model/common";
import BlockContent from "../BlockContent/BlockContent";
import startQuote from "./StartQuote.svg";
import endQuote from "./EndQuote.svg";
import styles from "./BlockQuote.module.scss";
import { imageUrlBuilder } from "../../utils/images";
import classNames from "classnames";

interface BlockQuoteProps {
  node: SanityBlockQuote;
  variant?: "landing" | "default";
}

const BlockQuote = ({
  node: { text, attribution, person },
  variant = "default"
}: BlockQuoteProps) => {
  const quote = (
    <blockquote className={classNames(styles.blockquote, styles[variant])}>
      <div className={styles.container}>
        <img className={styles.firstQuote} src={startQuote} alt="" />
        <BlockContent
          bodyVariant="blockquote"
          content={text}
          renderContainerOnSingleChild={false}
        />
        <img className={styles.endQuote} src={endQuote} alt="" />
      </div>
      <BlockContent
        className={styles.attribution}
        bodyVariant="defaultTiny"
        content={attribution}
      />
    </blockquote>
  );
  if (person) {
    const size = variant === "default" ? 114 : 160;
    return (
      <figure className={classNames(styles.photo, styles[variant])}>
        <img
          width={size}
          height={size}
          src={
            imageUrlBuilder
              .image(person.photo)
              .size(size, size)
              .fit("fill")
              .bg("fff")
              .url()!
          }
          alt={person.name}
        />
        {quote}
      </figure>
    );
  }
  return quote;
};

export default BlockQuote;
